import { RootState } from '../../types';

export const isSystemActive = (state: RootState) => state.settings.data?.isSystemActive;
export const getAppVersion = (state: RootState) => state.settings.data?.version;
export const isSystemLoading = (state: RootState) => state.settings.loading;
